export function useFetch() {

    const sendGet = async (url, headers) => {
        try {
            const response = await fetch(url, { headers });
            const json = response.status !== 204 ? await response.json() : '';
            return json;
        } 
        catch (error) {
            console.error(error);
            throw error;
        }
    }

    const sendPost = async (url, headers, body) => {
        try {
            const response = await fetch(url, {
                headers: {
                    'Content-Type': 'application/json',
                    ...headers
                },
                method: 'POST',                
                body: body
            });
            if(response.ok) {
                const json = response.status !== 204 ? await response.json() : '';
                return json;
            }
            else {
                if(response.status === 400) {
                    return response.text()
                        .then(function(err) {    
                            debugger;                        
                            throw new Error(err);
                        });
                }
                else {
                    throw new Error('Network response was not ok');
                }
            }
        } 
        catch (error) {
            console.error(error);
            throw error;
        }
    }

    return { sendGet, sendPost };
}